import React from 'react';
import clsx from 'clsx';
import {
    NameTextField
}
from '../../styling/Styles';
import DropdownMechanism from './DropdownMechanism';

const RadioMechanism = (props) => {

    const {
        hrefChecked,
        handleHrefChecked,
        handleHref,
        href,
        targetPageChecked,
        handleTargetPageChecked,
        target,
        targets,
        selectTarget,
        isFlowDataMechanism,
        isEditList,
        isButtonComponent,
        functionName,
        functionNameChecked,
        handleFunctionNameChecked,
        handleFunctionName,
        functionTargets
    } = props;


    return(
        <>  
            <div className={clsx('spacingTopDiv')}>
                
                <div className={clsx("radio-item")} onClick={handleHrefChecked} aria-hidden="true">
                    <input 
                        type='radio'
                        checked= {hrefChecked !== undefined ? hrefChecked : false}
                        style={{width: '1vw', height: '1vw'}}
                        onChange={() => {}}
                    />
                </div>
                &nbsp; Go to url: &nbsp; {isFlowDataMechanism === true && <span style={{display: 'inline-block', marginLeft: '4vw' }}>&nbsp;</span>}
                {isEditList === true || isButtonComponent === true && <span style={{display: 'inline-block', marginLeft: '3.8vw' }}>&nbsp;</span>} 
                <div style={{display: 'inline-flex', paddingTop: '0.5vw'}}>
                    <NameTextField
                        id='urlNameInput'
                        placeholder=' Url name'
                        onInput={e =>handleHref(e)}
                        value={href}
                    />
                </div>
                
            </div>
            <div 
                className={clsx('teamSelector', 'spacingTopDiv')} 
                >
                    <div className={clsx("radio-item")} onClick={handleTargetPageChecked} aria-hidden="true">
                        <input
                            type='radio'
                            checked= {targetPageChecked !== undefined ? targetPageChecked : false}
                            style={{width: '1vw', height: '1vw'}}
                            onChange={() => {}}
                        />
                    </div>
                        &nbsp; 
                    <span> Go to project page: &nbsp;
                        <DropdownMechanism
                            target = {target}
                            targets={targets}
                            selectTarget={selectTarget}
                        />
                    </span>
            </div>
            {functionNameChecked !== undefined && 
            
                <div 
                    className={clsx('teamSelector', 'spacingTopDiv')} 
                    >
                        <div className={clsx("radio-item")} style={{width: '1vw', height: '1vw'}} onClick={handleFunctionNameChecked} aria-hidden="true">
                            <input
                                type='radio'
                                checked= {functionNameChecked !== undefined ? functionNameChecked : false}   
                                onChange={handleFunctionNameChecked}
                            />
                        </div>  
                        &nbsp; 
                        <span> Method name: &nbsp; {isFlowDataMechanism === true && <span style={{display: 'inline-block', marginLeft: '1.5vw' }}>&nbsp;</span>}
                        {isEditList === true || isButtonComponent && <span style={{display: 'inline-block', marginLeft: '3.8vw' }}>&nbsp;</span>} 
                            <DropdownMechanism
                                target = {functionName}
                                targets={functionTargets}
                                selectTarget={handleFunctionName}
                            />
                        </span>
                </div>
            }          
        </>
    )

}

export default RadioMechanism;